module.exports = __webpack_public_path__ + "images/content-aggregation.6c7162c2.webp";